module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AW - Aruba.2ef3a2a3.svg";